import React from 'react'

// icons
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Sweet alert

// router
import { withRouter } from 'react-router-dom'
import useRecover from './hooks/useRecover'

const ItemDepartamentoEliminado = ({ departamento, setIsLoad }) => {
    const { recoverDepartamentoSubmit } = useRecover(setIsLoad)

    return (
        <tr>
            <th scope="row">{departamento.codigo}</th>
            <td>{departamento.nombre}</td>
            <td>{departamento.tasaIva}</td>
            <td>
                <button
                    className="btn text-warning"
                    onClick={() => {
                        recoverDepartamentoSubmit(departamento)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Recuperar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemDepartamentoEliminado)
